import { render, staticRenderFns } from "./AppointMaterialsModify.vue?vue&type=template&id=408bab52&scoped=true&"
import script from "./AppointMaterialsModify.vue?vue&type=script&lang=js&"
export * from "./AppointMaterialsModify.vue?vue&type=script&lang=js&"
import style0 from "./AppointMaterialsModify.vue?vue&type=style&index=0&id=408bab52&lang=less&scoped=true&"
import style1 from "./AppointMaterialsModify.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408bab52",
  null
  
)

export default component.exports